import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import '../host/ReviewRepliesList.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const AdminReviewRepliesList = () => {
    //sujay 9/6/2025 removiing select plafrom and taking it from the localstorage
    //const PlatformID = localStorage.getItem("platformID");
    //const [platforms, setPlatforms] = useState([]);
    //const [selectedPlatformId, setSelectedPlatformId] = useState('');
    const [submissions, setSubmissions] = useState([]);
    const [selectedSubmissionId, setSelectedSubmissionId] = useState('');
    const [reviews, setReviews] = useState([]);
    //Sujay 10/6/2025 Adding the isParent var beacause We need to hide the accept reject resubmit btn if paper has a revision for it
    //if paper is parent then it will give true 
    const [isParent, setIsParent] = useState(false);
    const [summary, setSummary] = useState({ Accepted: 0, AcceptWithComment: 0, totalReject: 0 });
    const [btnsVisiable, setBtnsVisiable] = useState({ accept: false, revision: false, reject: false })
    //sujay 24/5/2025 adding here variable of handle the view to list to matrix or matrix to list
    //const [isList, setIsList] = useState(true);
    const [revisionBtnName, setRevisionBtnName] = useState("Revision");
    const API = process.env.REACT_APP_API_BASE_URL;

    //sujay 18/6/2025 Adding the variables to store the authors 
    const [authors, setAuthors] = useState([]);
    const [selectedAuthorId, setSelectedAuthorId] = useState(null);

    //sujay 3/7/2025 cheaking that paper isReview or not
    const [isReview, setIsReview] = useState('');
    const platformId = localStorage.getItem('platformID')

    const defaultLayoutPluginInstance = defaultLayoutPlugin({
        toolbarPlugin: {
            toolbarSlot: (slots) => {
                const { Download, ...rest } = slots;
                return { ...rest };
            },
        },
    });

    //Sujay 18/6/2025 get the submission by the author wise
    //this Api is written in the subassignmentRoute but for the rewrite the api again therefore i use here to avoid repetion

    useEffect(() => {
        axios.get(`${API}/api/subassignments/authors`)
            .then(res => setAuthors(res.data))
            .catch(err => console.error(err));
    });

    //sujay 9/6/2025 removing select plafrom and taking it from the localstorage
    // useEffect(() => {
    //     axios.get(`${API}/api/review-replies/submissions/${PlatformID}`)
    //         .then(res => setSubmissions(res.data))
    //         .catch(err => console.error(err));
    // }, []);

    // useEffect(() => {
    //   axios.get('${API}/api/host/platforms')
    //     .then(res => setPlatforms(res.data))
    //     .catch(err => console.error(err));
    // }, []);

    // useEffect(() => {
    //   if (selectedPlatformId) {
    //     axios.get(`${API}/api/review-replies/submissions/${selectedPlatformId}`)
    //       .then(res => setSubmissions(res.data))
    //       .catch(err => console.error(err));
    //   }
    // }, [selectedPlatformId]);

    //get the submission by selected author and platfrom
    useEffect(() => {
        if (selectedAuthorId) {
            //here i make change only to get the submission by the selected AuthorId and onther code will be as like host review-replies
            axios.get(`${API}/api/admin/submissions/${selectedAuthorId}`)
                .then(res => setSubmissions(res.data))
                .catch(err => console.error(err));
        }
    }, [selectedAuthorId]);

    useEffect(() => {
        if (selectedSubmissionId) {
            axios.get(`${API}/api/review-replies/reviews/${selectedSubmissionId}`)
                .then(res => {
                    // Sujay 2/6/2025 we get the file also in the response
                    // sujay 10/6/2025 we get the paper has revision or not (isParent)
                    setReviews(res.data.reviews); // Set array only
                    setIsParent(res.data.isParent); // Separate flag
                    setIsReview(res.data.isReview);

                    // Sujay 4/6/2025 add the logic calculation related to the AcceptWithComment And RejectWithComment
                    const reviews = res.data.reviews;

                    // Track the first time each reviewer makes each decision
                    const decisionsByReviewer = new Map();

                    reviews.forEach(r => {
                        const prev = decisionsByReviewer.get(r.ReviewerID) || new Set();

                        // If this decision hasn't been recorded for this reviewer yet:
                        if (!prev.has(r.Decision)) {
                            prev.add(r.Decision);
                            decisionsByReviewer.set(r.ReviewerID, prev);
                        }
                    });

                    // Count unique decisions per type
                    let countAccept = 0;
                    let countAcceptWithComment = 0;
                    let countReject = 0;

                    decisionsByReviewer.forEach(decisionSet => {
                        if (decisionSet.has('AcceptWithComment')) countAcceptWithComment++;
                        if (decisionSet.has('Accept')) countAccept++;
                        if (decisionSet.has('Reject') || decisionSet.has('RejectWithComment')) countReject++;
                    });


                    const totalReject = countReject;
                    const totalAcceptWithComment = countAcceptWithComment;
                    const Accepted = countAccept;


                    setSummary({ Accepted, AcceptWithComment: totalAcceptWithComment, totalReject });

                    // Sujay 24/6/2025 adding the logic that shows the accept revision and reject button
                    let shouldResubmit =
                        // (totalAcceptWithComment >= 1) ||
                        (Accepted === 1 && totalReject === 1 && totalAcceptWithComment >= 1) ||
                        (Accepted === 1 && totalAcceptWithComment >= 2) ||
                        (Accepted >= 2 && totalAcceptWithComment >= 1) ||
                        (totalAcceptWithComment >= 2 && totalReject === 1) ||
                        (!isParent && Accepted >= 2);

                    let shouldAccept = (Accepted >= 3);
                    const shouldRejected = (totalReject >= 2);
                    //Sujay 24/6/2025 setting up the resubmit button according to the abstract and revision
                    const title = reviews[0].SubmissionTitle;

                    if (title && title.includes("Abstract")) {
                        setRevisionBtnName("Submit Full Paper");
                        shouldAccept = false;
                        if (Accepted >= 2 || totalAcceptWithComment >= 2) {
                            shouldResubmit = true;
                        }
                    } else if (title && title.includes("Full_Paper")) {
                        setRevisionBtnName("Submit Revision Paper");

                    } else if (title && title.includes("Revision")) {
                        shouldResubmit = false;
                        if (Accepted >= 2) {
                            shouldAccept = true;
                        }
                    }
                    setBtnsVisiable({ accept: shouldAccept, revision: shouldResubmit, reject: shouldRejected });
                })
                .catch(err => console.error(err));
        }
    }, [selectedSubmissionId]);



    const handleStatusChange = async (status) => {
        if (!selectedSubmissionId) {
            alert('Please select a submission.');
            return;
        }

        try {
            await axios.put(`${API}/api/reviewer-comments/update-status`, {
                submissionID: selectedSubmissionId,
                Status: status
            });

            alert(`Submission marked as ${status==="Pending" ? "revision" : status} successfully.`);

            const res = await axios.get(`${API}/api/review-replies/reviews/${selectedSubmissionId}`);
            setReviews(res.data);

        } catch (err) {
            console.error(err);
            alert('Failed to update submission status.');
        }
    };

    return (
        <div className="container mt-4">
            <h3 className="text-center mb-4 text-primary">📄 Review Replies List</h3>

            {/* sujay 9/6/2025 removiing select plafrom and taking it from the localstorage */}
            {/* <div className="mb-3">
                <label>Select Platform</label>
                <select className="form-select" value={selectedPlatformId} onChange={(e) => setSelectedPlatformId(e.target.value)}>
                    <option value="">-- Select Platform --</option>
                    {platforms.map(p => (
                        <option key={p.PlatformID} value={p.PlatformID}>{p.PlatformName}</option>
                    ))}
                </select>
            </div> */}

            <div className="mb-3">
                <label>Select Author</label>
                <select className="form-select" value={selectedAuthorId} onChange={(e) => setSelectedAuthorId(e.target.value)}>
                    <option value="">-- Select Author --</option>
                    {authors.map(s => (
                        <option key={s.AuthorID} value={s.AuthorID}>{s.AuthorName}</option>
                    ))}
                </select>
            </div>

            <div className="mb-3">
                <label>Select Submission</label>
                <select className="form-select" value={selectedSubmissionId} onChange={(e) => setSelectedSubmissionId(e.target.value)}>
                    <option value="">-- Select Submission --</option>
                    {submissions.map(s => (
                        <option key={s.submissionID} value={s.submissionID}>{s.SubmissionTitle}</option>
                    ))}
                </select>
            </div>

            <div className="alert alert-secondary">
                <strong> Accepted:</strong> {summary.Accepted} |
                <strong> Accept With comments:</strong> {summary.AcceptWithComment} |
                <strong> Total Reject:</strong> {summary.totalReject} |
                <strong > Accepted weightage:</strong> {((summary.Accepted - summary.totalReject)).toFixed(1)}

            </div>

            {/*sujay 3/6/2025 adding pdf column  */}
            {/* getting file name at 0th index */}
            {reviews.length > 0 && (
                <div className="row">
                    <div className="col-xl">
                        {reviews && reviews[0].File && reviews[0].File.endsWith('.pdf') ? (
                            <div className="border mb-3" style={{ height: '600px' }}>
                                <Worker workerUrl="/pdf.worker.min.js">
                                    <Viewer
                                        fileUrl={`${API}/uploads/papers/${reviews[0].File}`}
                                        plugins={[defaultLayoutPluginInstance]}
                                    />
                                </Worker>
                            </div>
                        ) : (
                            <div className="alert alert-warning">File is not a valid PDF</div>
                        )}

                        {/* Sujay 10/6/2025 hiding the btn if paper has revision paper of it */}

                        {!isParent && isReview.includes("Reviewing") ?
                            <div className="mb-3">
                                {(btnsVisiable.accept && !isParent) &&
                                    <button className="btn btn-success me-2" onClick={() => handleStatusChange('Accept')}>Accept</button>
                                }
                                {btnsVisiable.revision &&
                                    <button className="btn btn-warning me-2" onClick={() => handleStatusChange('Pending')}>{revisionBtnName}</button>
                                }
                                {btnsVisiable.reject &&
                                    <button className="btn btn-danger me-2" onClick={() => handleStatusChange('Reject')}>Reject Paper</button>
                                }
                                <button hidden className="btn btn-info me-2" onClick={() => handleStatusChange('RepliesUploaded')}>Mark Replies Uploaded</button>
                            </div> : <div class="alert alert-info fw-bold text-center mb-3 rounded shadow-sm" role="alert">
                                Action already taken
                            </div>

                        }
                    </div>
                    {/* //Sujay 12/6/2025 adding the table like structure */}
                    <div className="col-sm">
                        <table className="table table-bordered table-striped">
                            <thead>
                                <tr>
                                    <th>Reviewer</th>
                                    <th>Comment</th>
                                    <th>Decision</th>
                                    <th>Review Date</th>
                                    <th>Replied On</th>
                                    <th>Author Reply</th>
                                </tr>
                            </thead>
                            <tbody>
                                {reviews.map((r, index) => (
                                    <tr key={index}>
                                        <td>{r.ReviewerName || r.ReviewerID}</td>
                                        <td><strong>{r.Comment}</strong></td>
                                        <td>
                                            <span
                                                className={
                                                    r.Decision === 'Accept' || r.Decision === 'AcceptWithComment'
                                                        ? 'text-success fw-bold'
                                                        : r.Decision === 'Reject' || r.Decision === 'RejectWithComment'
                                                            ? 'text-danger fw-bold'
                                                            : ''
                                                }
                                            >
                                                {r.Decision === "AcceptWithComment" ? "Comment" : r.Decision}
                                            </span>
                                        </td>
                                        <td>{r.ReviewDate && new Date(r.ReviewDate).toLocaleDateString()}</td>
                                        <td>{r.AuthorReplayDate && new Date(r.AuthorReplayDate).toLocaleDateString()}</td>
                                        <td>{r.AuthorReply && <strong>{r.AuthorReply}</strong>}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminReviewRepliesList;
